<template>
    <div v-if="aberto" class="reauth-overlay" @click.self="cancelar">
        <div class="reauth-modal">
            <div class="reauth-header">
                <i class="las la-lock"></i>
                <h3>Sessão expirada</h3>
            </div>
            <p class="reauth-msg">
                Sua sessão expirou por inatividade. Confirme sua senha para continuar de onde parou — sem perder o que estava fazendo.
            </p>
            <form @submit.prevent="confirmar">
                <div class="reauth-input-wrap">
                    <i class="las la-key"></i>
                    <input
                        ref="campoSenha"
                        :type="mostrar ? 'text' : 'password'"
                        v-model="senha"
                        :disabled="enviando"
                        placeholder="Digite sua senha"
                        class="input-text with-border"
                        autocomplete="current-password"
                        required
                    >
                    <button type="button" tabindex="-1" class="reauth-toggle-olho" @click="mostrar = !mostrar">
                        <i :class="mostrar ? 'las la-eye-slash' : 'las la-eye'"></i>
                    </button>
                </div>

                <p v-if="erro" class="reauth-erro">{{ erro }}</p>

                <div class="reauth-acoes">
                    <button type="button" class="reauth-btn-secundario" :disabled="enviando" @click="sair">
                        <i class="las la-sign-out-alt"></i> Sair
                    </button>
                    <button type="submit" class="reauth-btn-primario" :disabled="enviando || !senha">
                        <i class="las la-check"></i>
                        {{ enviando ? "Validando..." : "Continuar" }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ModalReautenticacao',
    data () {
        return {
            aberto:     false,
            senha:      "",
            mostrar:    false,
            enviando:   false,
            erro:       "",
            resolvePromise: null
        }
    },
    methods: {
        abrir: function () {
            var self = this;
            // Esconde qualquer loader global que possa estar sobreposto (a request
            // original que disparou o 401 frequentemente abriu loading.show() e o
            // catch dela não chama hide).
            self.esconderLoaderGlobal();
            // Mantém escondido enquanto o modal está aberto — outras requests em
            // paralelo podem disparar loading.show() em cascata.
            if (self._loaderInterval) clearInterval(self._loaderInterval);
            self._loaderInterval = setInterval(function () {
                if (self.aberto) self.esconderLoaderGlobal();
                else { clearInterval(self._loaderInterval); self._loaderInterval = null; }
            }, 200);
            // Se já está aberto, retorna a promise existente (várias 401 chegam em sequência).
            if (self.aberto && self._promiseAtual) {
                return self._promiseAtual;
            }
            self.aberto    = true;
            self.senha     = "";
            self.erro      = "";
            self.enviando  = false;
            self._promiseAtual = new Promise(function (resolve) {
                self.resolvePromise = resolve;
            });
            self.$nextTick(function () {
                if (self.$refs.campoSenha) self.$refs.campoSenha.focus();
            });
            return self._promiseAtual;
        },
        esconderLoaderGlobal: function () {
            try {
                if (typeof loading !== 'undefined' && loading && typeof loading.hide === 'function') {
                    loading.hide();
                }
            } catch (e) {}
        },
        confirmar: function () {
            var self = this;
            if (!self.senha) return;
            self.esconderLoaderGlobal();
            self.enviando = true;
            self.erro     = "";
            axios.post("api/sessao-reautenticar.php", {
                _cod:   self.$root.user && self.$root.user.cod,
                _token: self.$root.user && self.$root.user.token,
                senha:  self.senha
            }, { authentication: true })
            .then(function (response) {
                self.enviando = false;
                self.aberto   = false;
                self.senha    = "";
                if (self.resolvePromise) self.resolvePromise(true);
                self._promiseAtual = null;
                if (self.$root && typeof self.$root.$emit === "function") {
                    self.$root.$emit('session-renewed');
                }
            })
            .catch(function (error) {
                self.enviando = false;
                if (error.response && error.response.data && error.response.data.erro === "senha-incorreta") {
                    self.erro = "Senha incorreta. Tente novamente.";
                } else if (error.response && error.response.status === 401) {
                    // Token inválido (não só expirado) — força logout.
                    self.erro = "Sessão inválida. Você precisa fazer login.";
                    setTimeout(function () { self.sair(); }, 1200);
                } else {
                    self.erro = (error.response && error.response.data && error.response.data.message) || "Erro ao validar a senha.";
                }
            });
        },
        cancelar: function () {
            // Clicar no fundo do overlay não fecha — sessão precisa ser resolvida.
        },
        sair: function () {
            var self = this;
            self.aberto = false;
            if (self.resolvePromise) self.resolvePromise(false);
            self._promiseAtual = null;
            try {
                window.localStorage.removeItem("_usuario");
                window.localStorage.removeItem("_usuario_temporario");
                window.localStorage.removeItem("_csrf_token");
            } catch (e) {}
            if (self.$root) {
                self.$root.logged   = false;
                self.$root.user     = { cod: null, token: null, areas: [], tipo: "contratante", tipos: [] };
                self.$root.userTemp = null;
                self.$root.csrfToken = null;
            }
            if (self.$root && typeof self.$root.go === "function") {
                self.$root.go("Login", JSON.stringify({ "reload": true }));
            } else {
                window.location.href = "#/login";
            }
        }
    }
}
</script>

<style scoped>
    .reauth-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.55);
        z-index: 2147483646; /* máximo - 1 (deixa espaço pra notificações críticas) */
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 16px;
        backdrop-filter: blur(2px);
    }
    .reauth-modal {
        background: #fff;
        border-radius: 12px;
        max-width: 420px;
        width: 100%;
        box-shadow: 0 20px 60px rgba(0,0,0,0.35);
        padding: 28px 26px 22px;
        animation: reauth-fade 0.18s ease-out;
    }
    @keyframes reauth-fade {
        from { opacity: 0; transform: translateY(-8px); }
        to   { opacity: 1; transform: translateY(0); }
    }
    .reauth-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
    }
    .reauth-header i {
        font-size: 30px;
        color: #ef6c00;
        background: #fff3e0;
        padding: 8px;
        border-radius: 50%;
    }
    .reauth-header h3 {
        margin: 0;
        font-size: 19px;
        font-weight: 600;
        color: #333;
    }
    .reauth-msg {
        color: #555;
        font-size: 14px;
        line-height: 1.45;
        margin-bottom: 18px;
    }
    .reauth-input-wrap {
        position: relative;
        margin-bottom: 12px;
    }
    .reauth-input-wrap > i.las.la-key {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #888;
        font-size: 18px;
        pointer-events: none;
    }
    .reauth-input-wrap input {
        width: 100%;
        padding-left: 38px;
        padding-right: 40px;
        height: 44px;
        font-size: 15px;
    }
    .reauth-toggle-olho {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        border: none;
        cursor: pointer;
        color: #888;
        padding: 6px;
    }
    .reauth-toggle-olho i {
        font-size: 18px;
    }
    .reauth-erro {
        color: #c62828;
        background: #ffebee;
        border: 1px solid #ffcdd2;
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 13px;
        margin: 0 0 12px 0;
    }
    .reauth-acoes {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        margin-top: 6px;
    }
    .reauth-btn-primario,
    .reauth-btn-secundario {
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        transition: opacity .15s ease;
    }
    .reauth-btn-primario {
        background: #2e7d32;
        color: #fff;
        border: 1px solid #2e7d32;
    }
    .reauth-btn-secundario {
        background: #fff;
        color: #666;
        border: 1px solid #ddd;
    }
    .reauth-btn-primario:disabled,
    .reauth-btn-secundario:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
    @media (max-width: 480px) {
        .reauth-modal { padding: 22px 18px 18px; }
        .reauth-header h3 { font-size: 17px; }
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalReautenticacao.vue